import React, { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const authHeaders = () => {
  const token = localStorage.getItem('session_token');
  return token ? { 'X-Session-Token': token } : {};
};

const AdjustmentItem = ({ a, isDarkMode }) => (
  <li data-testid={`plan-adjustment-${a.id}`} className={`py-2 border-b last:border-0 ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
    <div className="flex items-center justify-between gap-2">
      <span className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{a.client_name || 'Client'}</span>
      <span className={`text-xs px-2 py-0.5 rounded-full ${a.kind === 'nutrition' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
        {a.kind === 'nutrition' ? 'Nutrition' : 'Workout'}
      </span>
    </div>
    <p className={`text-xs mt-0.5 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>{a.summary}</p>
    {a.details?.changes && (
      <ul className={`text-xs mt-1 list-disc pl-4 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        {a.details.changes.slice(0, 4).map((c) => <li key={c}>{c}</li>)}
      </ul>
    )}
    <p className={`text-[11px] mt-1 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{new Date(a.created_at + 'Z').toLocaleString()}</p>
  </li>
);

export const PlanAdjustmentsPanel = ({ isDarkMode }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/trainer/plan-adjustments`, { credentials: 'include', headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : { adjustments: [] }))
      .then((d) => setItems(d.adjustments || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="plan-adjustments-panel" className={`mb-6 p-4 rounded-lg border ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
      <p className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Automatic progress adjustments</p>
      <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        Every Monday, upcoming workouts get new target weights from what clients logged, and calories shift when body weight stalls.
        New plans are built on the 1st of each month and sent here for your review.
      </p>
      {items === null ? null : items.length === 0 ? (
        <p data-testid="plan-adjustments-empty" className={`text-xs mt-3 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>No automatic adjustments yet.</p>
      ) : (
        <ul className="mt-2 max-h-72 overflow-y-auto">{items.map((a) => <AdjustmentItem key={a.id} a={a} isDarkMode={isDarkMode} />)}</ul>
      )}
    </div>
  );
};
